module.exports = __webpack_public_path__ + "static/media/Ascoli.2211f366.png";